import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.l5g().f50() : headers;
  return DelegatedCall().e5i(_this__u8e3s4.g5g_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static e5i(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.l5g().f50() : responseHeaders;
        var $this = this.f5i(client);
        $this.i5g_1 = new (DelegatedRequest())($this, originCall.g5i());
        $this.j5g_1 = new (DelegatedResponse())($this, originCall.l5g(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.l5i_1 = origin;
        this.m5i_1 = call;
      }
      n5i() {
        return this.m5i_1;
      }
      xv() {
        return this.l5i_1.xv();
      }
      o5i() {
        return this.l5i_1.o5i();
      }
      p5i() {
        return this.l5i_1.p5i();
      }
      h5i() {
        return this.l5i_1.h5i();
      }
      j2o() {
        return this.l5i_1.j2o();
      }
      f50() {
        return this.l5i_1.f50();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.f50() : headers;
        super();
        this.q5i_1 = call;
        this.r5i_1 = origin;
        this.s5i_1 = content;
        this.t5i_1 = headers;
        this.u5i_1 = this.r5i_1.xv();
      }
      n5i() {
        return this.q5i_1;
      }
      f50() {
        return this.t5i_1;
      }
      v5i() {
        return this.s5i_1(this.r5i_1);
      }
      xv() {
        return this.u5i_1;
      }
      w5i() {
        return this.r5i_1.w5i();
      }
      x5i() {
        return this.r5i_1.x5i();
      }
      y5i() {
        return this.r5i_1.y5i();
      }
      z5i() {
        return this.r5i_1.z5i();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
